module.exports = __webpack_public_path__ + "static/cookies-5475ca74a300257f91e70db922b40900.svg";